import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class TestService {
  constructor(private http: HttpClient) {}
  getRequest(data) {
    return this.http.get(`/api/Request/getRequest`, {
      params: {
        REQUEST_ID: data.requestId,
        PERSON_ID: data.personId
      },
      responseType: "json",
      observe: "response"
    });
  }

  getTest() {
    return this.http.get(`/api/Test/getTest`);
  }
  getTestNameById(testId) {
    return this.http.get(`/api/Test/getTestNameById`, {
      params: { type: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestNameByTestId(testId) {
    return this.http.get(`/api/Test/getTestNameById`, {
      params: { type: testId },
      responseType: "json"
    });
  }

  getTestDateName(testDateId) {
    return this.http.get(`/api/TestDate/getTestDateNameById`, {
      params: { type: testDateId },
      responseType: "json"
    });
  }

  getTestDateNameById(testDateId) {
    return this.http.get(`/api/TestDate/getTestDateNameById`, {
      params: { type: testDateId },
      responseType: "json",
      observe: "response"
    });
  }

  getStateTestDatesById(testDateId, mdmId) {
    return this.http.get(`/api/TestDate/getStateTestDatesById`, {
      params: { testId: testDateId, mdmId: mdmId },
      responseType: "json",
      observe: "response"
    });
  }
  getDates(testId) {
    return this.http.get(`/api/Test/getDates`, {
      params: { id: testId },
      responseType: "json",
      observe: "response"
    });
  }
  postPersonTest(data) {
    return this.http.post(`/api/PersonTest/createPersonTest`, data, {
      observe: "response"
    });
  }
  updateRequest(data) {
    return this.http.put(`/api/Request/updateRequestForTest`, data, {
      observe: "response"
    });
  }
  updatePersonTest(data) {
    return this.http.put(`/api/PersonTest/updatePersonTest`, data, {
      observe: "response"
    });
  }
  updatePersonTestCertifId(data) {
    return this.http.put(`/api/PersonTest/updatePersonTestCertifId`, data, {
      observe: "response"
    });
  }
  getPersonCount(data) {
    return this.http.get(`/api/PersonTest/getPersonsCount`, {
      params: { PERSON_ID: data.personId },
      responseType: "json",
      observe: "response"
    });
  }
  deleteAndCreateTest(data) {
    return this.http.post(`/api/PersonTest/deleteAndCreateTest`, data, {
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/test.service.ts